import React, { useEffect, useState } from "react"
import withRouter from "components/Common/withRouter"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import { Link, useLocation, useParams } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb"
import toast from "react-hot-toast"
import { updateHomePage, viewHomePage } from "helpers/fakebackend_helper"
import CustomTamilInput from "components/VerticalLayout/CustomTamilInput"
import ImagePopup from "./ImagePopup"

const HomePage = () => {
  const [activeTab, setactiveTab] = useState(1)
  const [activeTabVartical, setoggleTabVertical] = useState(1)

  const [passedSteps, setPassedSteps] = useState([1])
  const [passedStepsVertical, setPassedStepsVertical] = useState([1])
  const [show, setshow] = useState([true, true, true, true])
  const [navId, setNavId] = useState()
  const [slugs, setSlugs] = useState()
  const { state } = useLocation()
  const [btn, setBtn] = useState(false)
  const [showPopup, setShowPopup] = useState(false)
  const handleClose = () => setShowPopup(false)
  const [popType, setPopupType] = useState("")
  const [image_path, setImage_path] = useState("")

   const { slug } = useParams();

  // console.log("state", state)

  //   const [tab1, setTab1] = useState({
  //     image_path: "",
  //     eng_title: "",
  //     tamil_title: "",
  //     eng_sub_title: "",
  //     tamil_tsub_title: "",
  //     redirect_url: "",
  //     type:""
  //   })

  const [tab1, setTab1] = useState([
    {
      id: 1,
      image_path: "",
      eng_title: "",
      tamil_title: "",
      eng_sub_title: "",
      tamil_tsub_title: "",
      redirect_url: "",
      type: "",
    },
  ])

  const [tab2, setTab2] = useState({
    eng_title: "",
    tamil_title: "",
    eng_sub_title: "",
    tamil_tsub_title: "",
    empowering_lists: [
      {
        id: 1,
        emp_eng_title: "",
        emp_tamil_title: "",
        emp_eng_sub_title: "",
        emp_tamil_tsub_title: "",
        image_path: "",
        redirect_url: "",
      },
    ],
  })

  const [tab3, setTab3] = useState({
    eng_title: "",
    tamil_title: "",
    eng_sub_title: "",
    tamil_tsub_title: "",
    commitment_lists: [
      {
        id: 1,
        comm_eng_title: "",
        comm_tamil_title: "",
        comm_eng_sub_title: "",
        comm_tamil_tsub_title: "",
      },
    ],
  })

  const [tab4, setTab4] = useState({
    eng_title: "",
    tamil_title: "",
    eng_sub_title: "",
    tamil_tsub_title: "",
    gallery_lists: [
      {
        id: 1,
        gallery_eng_name: "",
        gallery_tamil_name: "",
        top1_image: "",
        top2_image: "",
        top3_image: "",
        left_center: "",
        center: "",
        right_center: "",
        bottom1_image: "",
        bottom2_image: "",
        bottom3_image: "",
      },
    ],
  })

  const handleTab1Change = (id, name, value) => {
    const updatedRows = tab1?.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setTab1(updatedRows)
  }

  const handleTab2Change = e => {
    const { name, value } = e.target
    setTab2(p => ({ ...p, [name]: value }))
  }

  const handleTab3Change = e => {
    const { name, value } = e.target
    setTab3(p => ({ ...p, [name]: value }))
  }

  const handleTab4Change = e => {
    const { name, value } = e.target
    setTab4(p => ({ ...p, [name]: value }))
  }

  const onAddFormRow1 = () => {
    let temp = [...tab1]
    const newRow = {
      id: Math.floor(Math.random() * (30 - 20)) + 20,
      image_path: "",
      eng_title: "",
      tamil_title: "",
      eng_sub_title: "",
      tamil_tsub_title: "",
      redirect_url: "",
      type: "",
    }
    temp.push(newRow)
    setTab1(temp)
  }

  const onAddFormRow = () => {
    const newRow = {
      id: Math.floor(Math.random() * (30 - 20)) + 20,
      emp_eng_title: "",
      emp_tamil_title: "",
      emp_eng_sub_title: "",
      emp_tamil_tsub_title: "",
      image_path: "",
      redirect_url: "",
    }
    setTab2({ ...tab2, empowering_lists: [...tab2.empowering_lists, newRow] })
  }

  const onAddFormRow2 = () => {
    const newRow = {
      id: Math.floor(Math.random() * (30 - 20)) + 20,
      comm_eng_title: "",
      comm_tamil_title: "",
      comm_eng_sub_title: "",
      comm_tamil_tsub_title: "",
    }
    setTab3({ ...tab3, commitment_lists: [...tab3.commitment_lists, newRow] })
  }

  const onAddFormRow3 = () => {
    const newRow = {
      id: Math.floor(Math.random() * (30 - 20)) + 20,
      gallery_eng_name: "",
      gallery_tamil_name: "",
      top1_image: "",
      top2_image: "",
      top3_image: "",
      left_center: "",
      center: "",
      right_center: "",
      bottom1_image: "",
      bottom2_image: "",
      bottom3_image: "",
    }
    setTab4({ ...tab4, gallery_lists: [...tab4.gallery_lists, newRow] })
  }

  const onDeleteFormRow = id => {
    const updatedRows = tab2.empowering_lists.filter(row => row.id !== id)
    setTab2({ ...tab2, empowering_lists: updatedRows })
  }

  const onDeleteFormRow2 = id => {
    const updatedRows = tab3.commitment_lists.filter(row => row.id !== id)
    setTab3({ ...tab3, commitment_lists: updatedRows })
  }

  const onDeleteFormRow3 = id => {
    const updatedRows = tab4.gallery_lists.filter(row => row.id !== id)
    setTab4({ ...tab4, gallery_lists: updatedRows })
  }

  const handleInputChange = (id, name, value) => {
    const updatedRows = tab2.empowering_lists.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setTab2({ ...tab2, empowering_lists: updatedRows })
  }

  const handleInputChange2 = (id, name, value) => {
    const updatedRows = tab3.commitment_lists.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setTab3({ ...tab3, commitment_lists: updatedRows })
  }

  const handleInputChange3 = (id, name, value) => {
    const updatedRows = tab4.gallery_lists.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setTab4({ ...tab4, gallery_lists: updatedRows })
  }

  const handleInputChange6 = (id, name, value) => {
    const updatedRows = tab6.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setTab6(updatedRows)
  }

  const handleTab1Verify = () => {
    if (tab1?.[0]?.type == "video") {
      if (tab1[0]?.type != "" && tab1[0]?.image_path != "") {
        return true
      } else {
        toast.error("Enter All Required Feilds!")
        return false
      }
    } else {
      if (
        tab1[0]?.type != "" &&
        tab1[0]?.tamil_title != "" &&
        tab1[0]?.eng_title != "" &&
        tab1[0]?.eng_sub_title != "" &&
        tab1[0]?.tamil_tsub_title != "" &&
        tab1[0]?.redirect_url != "" &&
        tab1[0]?.image_path != ""
      ) {
        return true
      } else {
        toast.error("Enter All Required Feilds!")
        return false
      }
    }
  }

  const handleTab2Verify = () => {
    if (
      tab2.eng_title != "" &&
      tab2.tamil_title != "" &&
      tab2.eng_sub_title != "" &&
      tab2.tamil_tsub_title != ""
    ) {
      return true
    } else if (tab2.empowering_lists?.length == 0) {
      toast.error("Add Empower Feilds!")
      return false
    } else {
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  const handleTab3Verify = () => {
    if (
      tab3.eng_title != "" &&
      tab3.tamil_title != "" &&
      tab3.eng_sub_title != "" &&
      tab3.tamil_tsub_title != ""
    ) {
      return true
    } else if (tab3?.commitment_lists.length == 0) {
      toast.error("Add Commitment Feilds!")
      return false
    } else {
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  const handleTab4Verify = () => {
    if (
      tab4.eng_title != "" &&
      tab4.tamil_title != "" &&
      tab4.eng_sub_title != "" &&
      tab4.tamil_tsub_title != ""
    ) {
      return true
    } else if (tab4?.gallery_lists.length == 0) {
      toast.error("Add Gallery Feilds!")
      return false
    } else {
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  const handleTab5Verify = () => {
    if (
      tab5?.[0]?.eng_desc != "" &&
      tab5?.[0]?.tamil_desc != "" &&
      tab5?.[0]?.redirect_url != "" &&
      tab5?.[0]?.eng_title != "" &&
      tab5?.[0]?.tamil_title != "" &&
      tab5?.[1]?.eng_desc != "" &&
      tab5?.[1]?.tamil_desc != "" &&
      tab5?.[1]?.redirect_url != "" &&
      tab5?.[1]?.eng_title != "" &&
      tab5?.[1]?.tamil_title != ""
    ) {
      return true
    } else {
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  const handleTab6Verify = () => {
    if (
      tab6?.[0]?.image_path != "" &&
      tab6?.[0]?.redirect_url != ""
    ) {
      handleSubmitForm()
    } else {
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab]
      if (tab >= 1 && tab <= 6) {
        setactiveTab(tab)
        setPassedSteps(modifiedSteps)
      }
    }
  }

  function toggleTabVertical(tab) {
    if (activeTabVartical !== tab) {
      var modifiedSteps = [...passedStepsVertical, tab]

      if (tab >= 1 && tab <= 4) {
        setoggleTabVertical(tab)
        setPassedStepsVertical(modifiedSteps)
      }
    }
  }

  const [isLoading, setisLoading] = useState(false)

  const [tab5, setTab5] = useState([
    {
      id: "",
      eng_title: "",
      tamil_title: "",
      eng_desc: "",
      tamil_desc: "",
      redirect_url: "",
    },
  ])

  const [tab6, setTab6] = useState([
    {
      id: "",
      image_path: "",
      redirect_url: ""
    },
  ])

  const onAddFormRow5 = () => {
    const newRow = {
      id: Math.floor(Math.random() * (30 - 20)) + 20,
      eng_desc1: "",
      tamil_desc1: "",
      eng_desc2: "",
      tamil_desc2: "",
    }
    setTab5([...tab5, newRow])
  }

  const onAddFormRow6 = () => {
    const newRow = {
      id: Math.floor(Math.random() * (30 - 20)) + 20,
      image_path: "",
      redirect_url: ""
    }
    setTab6([...tab6, newRow])
  }

  const onDeleteFormRow5 = id => {
    const updatedRows = tab5.filter(row => row.id !== id)
    setTab5(updatedRows)
  }

  const onDeleteFormRow6 = id => {
    const updatedRows = tab6.filter(row => row.id !== id)
    setTab6(updatedRows)
  }

  const onDeleteFormRow1 = id => {
    const updatedRows = tab1.filter(row => row.id !== id)
    setTab1(updatedRows)
  }

  const handleInputChange5 = (id, name, value) => {
    const updatedRows = tab5.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setTab5(updatedRows)
  }

  const getTemplete = navigation_id => {
    let payload = new FormData()
    payload.append('navigation_template_id', slug)
    // let payload ={
    //     navigation_id:navigation_id
    // }
    viewHomePage(payload)
      .then(res => {
        let data = res?.response
        if (data?.banner_json?.banner_lists) {
          let empowering_lists_ = Object.values(data?.banner_json?.banner_lists)
          let empowering_lists = []
          empowering_lists_?.map((item, ind) => {
            empowering_lists.push({
              ...item,
              id: ind + 1,
            })
          })
          setTab1(empowering_lists)
        }

        // TAB 2
        if (data?.empowering_json) {
          let empowering_section = data?.empowering_json
          let empowering_lists_ = Object.values(
            data?.empowering_json?.empowering_lists
          )
          let empowering_lists = []
          empowering_lists_?.map((item, ind) => {
            empowering_lists.push({
              ...item,
              id: ind + 1,
            })
          })
          let empowering = {
            ...empowering_section,
          }
          empowering.empowering_lists = empowering_lists
          setTab2(empowering)
        }

        if (data?.commitment_json) {
          // TAB 3
          let commitment_section = data?.commitment_json
          let commitment_lists_ = Object.values(
            data?.commitment_json?.commitment_lists
          )
          let commitment_lists = []
          commitment_lists_?.map((item, ind) => {
            commitment_lists.push({
              ...item,
              id: ind + 1,
            })
          })
          let commitment = {
            ...commitment_section,
          }
          commitment.commitment_lists = commitment_lists
          setTab3(commitment)
        }

        if (data?.gallery_json) {
          // TAB 4
          let gallery_section = data?.gallery_json
          let gallery_lists_ = Object.values(data?.gallery_json?.gallery_lists)
          let gallery_lists = []
          gallery_lists_?.map((item, ind) => {
            gallery_lists.push({
              ...item,
              id: ind + 1,
            })
          })
          let gallery = {
            ...gallery_section,
          }
          gallery.gallery_lists = gallery_lists
          setTab4(gallery)
        }

        if (data?.new_updates_json) {
          // TAB 5
          let gallery_section = data?.new_updates_json
          let gallery_lists_ = Object.values(
            data?.new_updates_json?.new_updates
          )

          let quick_links_ = Object.values(
            data?.new_updates_json?.quick_links
          )

          let gallery_lists = []
          gallery_lists_?.map((item, ind) => {
            gallery_lists.push({
              ...item,
              id: ind + 1,
            })
          })

          let quick_links = []
          quick_links_?.map((item, ind) => {
            quick_links.push({
              ...item,
              id: ind + 1,
            })
          })
          // gallery.new_updates = gallery_lists
          // console.log('gallery_lists', gallery_lists);

          setTab5(gallery_lists)
          setTab6(quick_links)
        }
      })
      .catch(err => {
        console.log("err", err)
      })
  }

  useEffect(() => {
    if (state?.data?.id) {
      setNavId(state?.data?.id)
      getTemplete(state?.data?.slug)
      setSlugs(state?.data?.slug)
    }

        if(slug){
      getTemplete()
  }
  }, [state])

  const handleSubmitForm = () => {
    var formData = new FormData()

    // formData.append("navigation_id", navId ?? slug)
    formData.append('navigation_template_id', slug)

    // tab 1
    tab1?.map((item, ind) => {
      formData.append(
        `banner_json[banner_lists][${ind}][image_path]`,
        item?.image_path
      )
      formData.append(
        `banner_json[banner_lists][${ind}][tamil_title]`,
        item?.type == "video" ? "null" : item?.tamil_title
      )
      formData.append(
        `banner_json[banner_lists][${ind}][eng_title]`,
        item?.type == "video" ? "null" : item?.eng_title
      )
      formData.append(
        `banner_json[banner_lists][${ind}][eng_sub_title]`,
        item?.type == "video" ? "null" : item?.eng_sub_title
      )
      formData.append(
        `banner_json[banner_lists][${ind}][tamil_tsub_title]`,
        item?.type == "video" ? "null" : item?.tamil_tsub_title
      )
      formData.append(
        `banner_json[banner_lists][${ind}][redirect_url]`,
        item?.type == "video" ? "null" : item?.redirect_url
      )
      formData.append(`banner_json[banner_lists][${ind}][type]`, item?.type)
    })

    // tab 2
    formData.append(`empowering_json[eng_title]`, tab2?.eng_title)
    formData.append(`empowering_json[tamil_title]`, tab2?.tamil_title)
    formData.append(`empowering_json[eng_sub_title]`, tab2?.eng_sub_title)
    formData.append(`empowering_json[tamil_tsub_title]`, tab2?.tamil_tsub_title)

    tab2?.empowering_lists?.map((data, i) => {
      formData.append(
        `empowering_json[empowering_lists][${i}][image_path]`,
        data.image_path
      )
      formData.append(
        `empowering_json[empowering_lists][${i}][emp_tamil_title]`,
        data.emp_tamil_title
      )
      formData.append(
        `empowering_json[empowering_lists][${i}][emp_tamil_tsub_title]`,
        data.emp_tamil_tsub_title
      )
      formData.append(
        `empowering_json[empowering_lists][${i}][emp_eng_title]`,
        data.emp_eng_title
      )
      formData.append(
        `empowering_json[empowering_lists][${i}][emp_eng_sub_title]`,
        data.emp_eng_sub_title
      )
      formData.append(
        `empowering_json[empowering_lists][${i}][redirect_url]`,
        data.redirect_url
      )
    })

    // tab 3
    formData.append("commitment_json[eng_title]", tab3?.eng_title)
    formData.append("commitment_json[tamil_title]", tab3?.tamil_title)
    formData.append("commitment_json[eng_sub_title]", tab3?.eng_sub_title)
    formData.append("commitment_json[tamil_tsub_title]", tab3?.tamil_tsub_title)

    tab3?.commitment_lists?.map((data, i) => {
      formData.append(
        `commitment_json[commitment_lists][${i}][comm_eng_title]`,
        data.comm_eng_title
      )
      formData.append(
        `commitment_json[commitment_lists][${i}][comm_eng_sub_title]`,
        data.comm_eng_sub_title
      )
      formData.append(
        `commitment_json[commitment_lists][${i}][comm_tamil_title]`,
        data.comm_tamil_title
      )
      formData.append(
        `commitment_json[commitment_lists][${i}][comm_tamil_tsub_title]`,
        data.comm_tamil_tsub_title
      )
    })

    // tab 4
    formData.append("gallery_json[eng_title]", tab4?.eng_title)
    formData.append("gallery_json[tamil_title]", tab4?.tamil_title)
    formData.append("gallery_json[eng_sub_title]", tab4?.eng_sub_title)
    formData.append("gallery_json[tamil_tsub_title]", tab4?.tamil_tsub_title)

    tab4.gallery_lists?.map((data, i) => {
      formData.append(
        `gallery_json[gallery_lists][${i}][bottom1_image]`,
        data.bottom1_image
      )
      formData.append(
        `gallery_json[gallery_lists][${i}][bottom2_image]`,
        data.bottom2_image
      )
      formData.append(
        `gallery_json[gallery_lists][${i}][bottom3_image]`,
        data.bottom3_image
      )
      formData.append(`gallery_json[gallery_lists][${i}][center]`, data.center)
      formData.append(
        `gallery_json[gallery_lists][${i}][gallery_eng_name]`,
        data.gallery_eng_name
      )
      formData.append(
        `gallery_json[gallery_lists][${i}][gallery_tamil_name]`,
        data.gallery_tamil_name
      )
      formData.append(
        `gallery_json[gallery_lists][${i}][left_center]`,
        data.left_center
      )
      formData.append(
        `gallery_json[gallery_lists][${i}][right_center]`,
        data.right_center
      )
      formData.append(
        `gallery_json[gallery_lists][${i}][top1_image]`,
        data.top1_image
      )
      formData.append(
        `gallery_json[gallery_lists][${i}][top2_image]`,
        data.top2_image
      )
      formData.append(
        `gallery_json[gallery_lists][${i}][top3_image]`,
        data.top3_image
      )
    })

    tab5?.map((data, i) => {
      formData.append(
        `new_updates_json[new_updates][${i}][eng_title]`,
        data.eng_title
      )
      formData.append(
        `new_updates_json[new_updates][${i}][tamil_title]`,
        data.tamil_title
      )
      formData.append(
        `new_updates_json[new_updates][${i}][eng_desc]`,
        data.eng_desc
      )
      formData.append(
        `new_updates_json[new_updates][${i}][tamil_desc]`,
        data.tamil_desc
      )
      formData.append(
        `new_updates_json[new_updates][${i}][redirect_url]`,
        data.redirect_url
      )
    })

    tab6?.map((data, i) => {
      formData.append(
        `new_updates_json[quick_links][${i}][image_path]`,
        data.image_path
      )
      formData.append(
        `new_updates_json[quick_links][${i}][redirect_url]`,
        data.redirect_url
      )
  })

    // formData.append('banner_section', `${JSON.stringify(tab1)}`)
    // formData.append('empowering_section', `${JSON.stringify(tab2)}`)
    // formData.append('commitment_section', `${JSON.stringify(tab3)}`)
    // formData.append('gallery_section', `${JSON.stringify(tab4)}`)

    // formData.append('gallery_section', `{
    // "eng_title": ${tab4?.eng_title} ,
    // "tamil_title": ${tab4?.tamil_title} ,
    // "eng_sub_title": ${tab4?.eng_sub_title} ,
    // "tamil_tsub_title": ${tab4?.tamil_tsub_title} ,
    // }`)

    // formData.append('commitment_section', `{
    //     "eng_title": ${tab3?.eng_title} ,
    //     "tamil_title": ${tab3?.tamil_title} ,
    //     "eng_sub_title": ${tab3?.eng_sub_title} ,
    //     "tamil_tsub_title": ${tab3?.tamil_tsub_title} ,
    //     "commitment_lists": ${JSON.stringify(tab3.commitment_lists)}
    // }`)
    // formData.append('banner_section', `{
    //             "eng_title": ${tab1?.eng_title} ,
    //             "tamil_title": ${tab1?.tamil_title} ,
    //             "eng_sub_title": ${tab1?.eng_sub_title} ,
    //             "tamil_tsub_title": ${tab1?.tamil_tsub_title} ,
    //             "redirect_url": ${tab1?.redirect_url}
    //  }`)
    // formData.append('empowering_section', `{
    //         "eng_title": ${tab2?.eng_title} ,
    //         "tamil_title": ${tab2?.tamil_title} ,
    //         "eng_sub_title": ${tab2?.eng_sub_title} ,
    //         "tamil_tsub_title": ${tab2?.tamil_tsub_title} ,
    //     }`)

    setisLoading(true)
    updateHomePage(formData)
      .then(res => {
        setisLoading(false)
        if (res?.success) {
          toast.success("Added Success")
          getTemplete(state?.data?.slug)
          // router(-1)
        } else {
          toast.error(res?.message ?? "somthing went wrong!")
        }
      })
      .catch(err => {
        setisLoading(false)
        toast.error(err.message)
      })
  }

  const getImg = (image_, type) => {
    setImage_path(image_)
    setPopupType(type)
    setShowPopup(true)
  }

  return (
    <>
      <ImagePopup
        showPopup={showPopup}
        handleClose={handleClose}
        image_path={image_path}
        popType={popType}
      />
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            title="Dashboard"
            breadcrumbItem={state?.data?.type ?? ''}
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* <h4 className="card-title mb-4">Home</h4> */}
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        <NavItem
                          className={classnames({ current: activeTab === 1 })}
                        >
                          <NavLink
                            className={classnames({ current: activeTab === 1 })}
                            onClick={() => {
                              setactiveTab(1)
                            }}
                            disabled={!(passedSteps || []).includes(1)}
                          >
                            <span className="text-truncate">
                              <span className="number">1.</span>
                              Banner Section
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 2 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 2 })}
                            onClick={() => {
                              setactiveTab(2)
                            }}
                            disabled={!(passedSteps || []).includes(2)}
                          >
                            <span className="text-truncate">
                              <span className="number">2.</span>
                              Empowering Section
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 3 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 3 })}
                            onClick={() => {
                              setactiveTab(3)
                            }}
                            disabled={!(passedSteps || []).includes(3)}
                          >
                            <span className="text-truncate">
                              <span className="number">3.</span> Commitment
                              Section
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 4 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 4 })}
                            onClick={() => {
                              setactiveTab(4)
                            }}
                            disabled={!(passedSteps || []).includes(4)}
                          >
                            <span className="text-truncate">
                              <span className="number">4.</span> Gallery Section
                            </span>
                          </NavLink>
                        </NavItem>

                        <NavItem
                          className={classnames({ current: activeTab === 5 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 5 })}
                            onClick={() => {
                              setactiveTab(5)
                            }}
                            disabled={!(passedSteps || []).includes(5)}
                          >
                            <span className="text-truncate">
                              <span className="number">5.</span> News Feeds
                            </span>
                          </NavLink>
                        </NavItem>

                        <NavItem
                          className={classnames({ current: activeTab === 6 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 6 })}
                            onClick={() => {
                              setactiveTab(6)
                            }}
                            disabled={!(passedSteps || []).includes(6)}
                          >
                            <span className="text-truncate">
                              <span className="number">6.</span>Quick Links
                            </span>
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>

                    <div className="content clearfix">
                      <TabContent activeTab={activeTab} className="body">
                        <TabPane tabId={1}>
                          {/* <div className="d-flex justify-content-end w-100">
                                                        <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                                            setshow((p) => {
                                                                const h = [...p];
                                                                h[0] = !h[0];
                                                                return h;
                                                            })
                                                        }}>{show[0] ? "Show" : 'Hidden'}</button>
                                                    </div> */}
                          <div>
                            {tab1?.map((item, ind) => {
                              return (
                                <div key={ind}>
                                  <Row>
                                    <Col lg="6">
                                      <div className="mb-3">
                                        <Label for="imag">
                                          Type{" "}
                                          <span className="text-danger">*</span>
                                        </Label>
                                        <select
                                          onChange={e =>
                                            handleTab1Change(
                                              item?.id,
                                              "type",
                                              e.target.value
                                            )
                                          }
                                          value={item?.type}
                                          className="form-control"
                                        >
                                          <option value={""}>
                                            Select Type
                                          </option>
                                          <option value={"image"}>Image</option>
                                          <option value={"video"}>Video</option>
                                        </select>
                                      </div>
                                    </Col>

                                    <Col lg="6">
                                      <div className="mb-3">
                                        <Label for="imag">
                                          {item?.type == "video"
                                            ? "Video"
                                            : "Image"}
                                          <span className="text-danger">*</span>
                                        </Label>
                                        <Input
                                          type="file"
                                          onChange={e =>
                                            handleTab1Change(
                                              item?.id,
                                              "image_path",
                                              e.target.files[0]
                                            )
                                          }
                                          className="form-control"
                                          id="imag"
                                          placeholder="Enter Your Email ID"
                                        />
                                      </div>

                                      {item?.image_path && (
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          onClick={() => {
                                            getImg(item?.image_path, item?.type)
                                          }}
                                        >
                                          Preview
                                        </button>
                                      )}
                                    </Col>
                                    <Col lg="6">
                                      <div className="mb-3">
                                        <Label for="basicpill-firstname-input1">
                                          English Title{" "}
                                          <span className="text-danger">*</span>
                                        </Label>
                                        <Input
                                          type="text"
                                          name="eng_title"
                                          onChange={e =>
                                            handleTab1Change(
                                              item?.id,
                                              "eng_title",
                                              e.target.value
                                            )
                                          }
                                          value={item?.eng_title}
                                          className="form-control"
                                          id="basicpill-firstname-input1"
                                          placeholder="Enter English Title"
                                          disabled={
                                            item?.type == "video" ? true : false
                                          }
                                        />
                                      </div>
                                    </Col>
                                    <Col lg="6">
                                      <div className="mb-3">
                                        <Label for="basicpill-lastname-input2">
                                          Tamil Title{" "}
                                          <span className="text-danger">*</span>
                                        </Label>
                                        <CustomTamilInput
                                          value={item?.tamil_title}
                                          setValue={e =>
                                            handleTab1Change(
                                              item?.id,
                                              "tamil_title",
                                              e
                                            )
                                          }
                                          disabled={
                                            item?.type == "video" ? true : false
                                          }
                                        />
                                        {/* <Input
                                                                        type="text"
                                                                        onChange={handleTab1Change}
                                                                        name="tamil_title"
                                                                        className="form-control"
                                                                        id="basicpill-lastname-input2"
                                                                        placeholder="Enter Tamil Title"
                                                                    /> */}
                                      </div>
                                    </Col>
                                  </Row>

                                  <Row>
                                    <Col lg="6">
                                      <div className="mb-3">
                                        <Label for="basicpill-phoneno-input3">
                                          English Sub Title{" "}
                                          <span className="text-danger">*</span>
                                        </Label>
                                        <Input
                                          type="text"
                                          name="eng_sub_title"
                                          className="form-control"
                                          id="basicpill-phoneno-input3"
                                          placeholder="Enter English Sub Title"
                                          onChange={e =>
                                            handleTab1Change(
                                              item?.id,
                                              "eng_sub_title",
                                              e.target.value
                                            )
                                          }
                                          value={item?.eng_sub_title}
                                          disabled={
                                            item?.type == "video" ? true : false
                                          }
                                        />
                                      </div>
                                    </Col>

                                    <Col lg="6">
                                      <div className="mb-3">
                                        <Label for="tamilSub">
                                          Tamil Sub Title{" "}
                                          <span className="text-danger">*</span>
                                        </Label>
                                        {/* <Input
                                                                        type="text"
                                                                        onChange={handleTab1Change}
                                                                        name="tamil_tsub_title"
                                                                        className="form-control"
                                                                        id="tamilSub"
                                                                        placeholder="Enter Tamil Sub Title"
                                                                    /> */}
                                        <CustomTamilInput
                                          value={item?.tamil_tsub_title}
                                          setValue={e =>
                                            handleTab1Change(
                                              item?.id,
                                              "tamil_tsub_title",
                                              e
                                            )
                                          }
                                          disabled={
                                            item?.type == "video" ? true : false
                                          }
                                        />
                                      </div>
                                    </Col>

                                    <Col lg="6">
                                      <div className="mb-3">
                                        <Label for="basicpill-url">
                                          Redirect URL{" "}
                                          <span className="text-danger">*</span>
                                        </Label>
                                        <Input
                                          type="url"
                                          name="redirect_url"
                                          className="form-control"
                                          id="basicpill-url"
                                          placeholder="Enter Redirect URL"
                                          onChange={e =>
                                            handleTab1Change(
                                              item?.id,
                                              "redirect_url",
                                              e.target.value
                                            )
                                          }
                                          value={item?.redirect_url}
                                          disabled={
                                            item?.type == "video" ? true : false
                                          }
                                        />
                                      </div>
                                    </Col>

                                    {ind > 0 && (
                                      <Col
                                        lg={2}
                                        className="mb-2 align-self-center"
                                      >
                                        <div className="d-grid">
                                          <input
                                            type="button"
                                            className="btn btn-danger"
                                            value="Delete"
                                            onClick={() =>
                                              onDeleteFormRow1(item?.id)
                                            }
                                          />
                                        </div>
                                      </Col>
                                    )}
                                  </Row>
                                </div>
                              )
                            })}
                            <input
                              type="button"
                              className="btn btn-success mt-3 mt-lg-0"
                              value="Add Banner"
                              onClick={() => onAddFormRow1()}
                            />
                          </div>
                        </TabPane>

                        <TabPane tabId={2}>
                          <div>
                            {/* <div className="d-flex justify-content-end w-100">
                                                            <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                                                setshow((p) => {
                                                                    const h = [...p];
                                                                    h[1] = !h[1];
                                                                    return h;
                                                                })
                                                            }}>{show[1] ? "Show" : 'Hidden'}</button>
                                                        </div> */}
                            <Form>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-eng-input5">
                                      English Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      type="text"
                                      name="eng_title"
                                      onChange={handleTab2Change}
                                      className="form-control"
                                      id="basicpill-eng-input5"
                                      placeholder="Enter English Title."
                                      value={tab2?.eng_title}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-hgsd-input6">
                                      Tamil Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    {/* <Input
                                                                            type="text"
                                                                            name="tamil_title"
                                                                            onChange={handleTab2Change}
                                                                            className="form-control"
                                                                            id="basicpill-hgsd-input6"
                                                                            placeholder="Enter Tamil Title."
                                                                        /> */}
                                    <CustomTamilInput
                                      value={tab2.tamil_title}
                                      name={"tamil_title"}
                                      setValue={e =>
                                        setTab2(p => ({ ...p, tamil_title: e }))
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-suib-input7">
                                      English Sub Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      type="text"
                                      name="eng_sub_title"
                                      onChange={handleTab2Change}
                                      className="form-control"
                                      id="basicpill-suib-input7"
                                      placeholder="Enter English Sub Title."
                                      value={tab2?.eng_sub_title}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-ygksd-input8">
                                      Tamil Sub Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CustomTamilInput
                                      value={tab2.tamil_tsub_title}
                                      name={"tamil_tsub_title"}
                                      setValue={e =>
                                        setTab2(p => ({
                                          ...p,
                                          tamil_tsub_title: e,
                                        }))
                                      }
                                    />
                                    {/* <Input
                                                                            type="text"
                                                                            name="tamil_tsub_title"
                                                                            onChange={handleTab2Change}
                                                                            className="form-control"
                                                                            id="basicpill-ygksd-input8"
                                                                            placeholder="Enter Tamil Sub Title."
                                                                        /> */}
                                  </div>
                                </Col>
                              </Row>
                            </Form>

                            <h6 className="mb-3 mt-3 card-title">
                              Empowering <span className="text-danger">*</span>
                            </h6>
                            <Form
                              className="repeater"
                              encType="multipart/form-data"
                            >
                              <div>
                                {(tab2.empowering_lists || []).map(
                                  (formRow, key) => (
                                    <Row
                                      key={key}
                                      className="align-items-center"
                                    >
                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="emp_eng_title">
                                          English Title
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          id="emp_eng_title"
                                          name={`emp_eng_title_${formRow.id}`}
                                          value={formRow.emp_eng_title}
                                          onChange={e =>
                                            handleInputChange(
                                              formRow.id,
                                              "emp_eng_title",
                                              e.target.value
                                            )
                                          }
                                          className="form-control"
                                          placeholder="Enter English Title"
                                        />
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="emp_tamil_title">
                                          Tamil Title
                                          <span className="text-danger">*</span>
                                        </label>
                                        <CustomTamilInput
                                          value={formRow.emp_tamil_title}
                                          name={`emp_tamil_title_${formRow.id}`}
                                          setValue={e =>
                                            handleInputChange(
                                              formRow.id,
                                              "emp_tamil_title",
                                              e
                                            )
                                          }
                                        />
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="emp_eng_sub_title">
                                          English Sub Title
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          id="emp_eng_sub_title"
                                          name={`emp_eng_sub_title_${formRow.id}`}
                                          value={formRow.emp_eng_sub_title}
                                          onChange={e =>
                                            handleInputChange(
                                              formRow.id,
                                              "emp_eng_sub_title",
                                              e.target.value
                                            )
                                          }
                                          className="form-control"
                                          placeholder="Enter English Sub Title"
                                        />
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="emp_tamil_tsub_title">
                                          Tamil Sub Title
                                          <span className="text-danger">*</span>
                                        </label>
                                        {/* <input
                                                                                type="text"
                                                                                id="emp_tamil_tsub_title"
                                                                                name={`emp_tamil_tsub_title_${formRow.id}`}
                                                                                value={formRow.emp_tamil_tsub_title}
                                                                                onChange={(e) => handleInputChange(formRow.id, 'emp_tamil_tsub_title', e.target.value)}
                                                                                className="form-control"
                                                                                placeholder="Enter Tamil Sub Title"
                                                                            /> */}
                                        <CustomTamilInput
                                          value={formRow.emp_tamil_tsub_title}
                                          name={`emp_tamil_tsub_title_${formRow.id}`}
                                          setValue={e =>
                                            handleInputChange(
                                              formRow.id,
                                              "emp_tamil_tsub_title",
                                              e
                                            )
                                          }
                                        />
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="redirect_url">
                                          Redirect Url
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          id="redirect_url"
                                          name={`redirect_url_${formRow.id}`}
                                          value={formRow.redirect_url}
                                          onChange={e =>
                                            handleInputChange(
                                              formRow.id,
                                              "redirect_url",
                                              e.target.value
                                            )
                                          }
                                          className="form-control"
                                          placeholder="Enter Redirect url"
                                        />
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="image_path">
                                          Image
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="file"
                                          className="form-control"
                                          id="image_path"
                                          name={`image_path_${formRow.id}`}
                                          // value={formRow.image_path}
                                          onChange={e =>
                                            handleInputChange(
                                              formRow.id,
                                              "image_path",
                                              e.target.files[0]
                                            )
                                          }
                                        />
                                        {formRow.image_path && (
                                          <div
                                            className="btn btn-primary mt-1"
                                            type="button"
                                            onClick={() => {
                                              getImg(formRow?.image_path)
                                            }}
                                          >
                                            Preview
                                          </div>
                                        )}
                                      </Col>

                                      {key > 0 && (
                                        <Col
                                          lg={2}
                                          className="mb-2 align-self-center"
                                        >
                                          <div className="d-grid">
                                            <input
                                              type="button"
                                              className="btn btn-danger"
                                              value="Delete"
                                              onClick={() =>
                                                onDeleteFormRow(formRow.id)
                                              }
                                            />
                                          </div>
                                        </Col>
                                      )}
                                    </Row>
                                  )
                                )}
                              </div>
                              <input
                                type="button"
                                className="btn btn-success mt-3 mt-lg-0"
                                value="Add Empowering"
                                onClick={() => onAddFormRow()}
                              />
                            </Form>
                          </div>
                        </TabPane>

                        <TabPane tabId={3}>
                          <div>
                            {/* <div className="d-flex justify-content-end w-100">
                                                            <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                                                setshow((p) => {
                                                                    const h = [...p];
                                                                    h[2] = !h[2];
                                                                    return h;
                                                                })
                                                            }}>{show[2] ? "Show" : 'Hidden'}</button>

                                                        </div> */}

                            <Form>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-eng-input5">
                                      English Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      type="text"
                                      name="eng_title"
                                      onChange={handleTab3Change}
                                      className="form-control"
                                      id="basicpill-eng-input5"
                                      placeholder="Enter English Title."
                                      value={tab3?.eng_title}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-hgsd-input6">
                                      Tamil Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CustomTamilInput
                                      value={tab3.tamil_title}
                                      name={"tamil_title"}
                                      setValue={e =>
                                        setTab3(p => ({ ...p, tamil_title: e }))
                                      }
                                    />
                                    {/* <Input
                                                                            type="text"
                                                                            name="tamil_title"
                                                                            onChange={handleTab3Change}
                                                                            className="form-control"
                                                                            id="basicpill-hgsd-input6"
                                                                            placeholder="Enter Tamil Title."
                                                                        /> */}
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-suib-input7">
                                      English Sub Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      type="text"
                                      name="eng_sub_title"
                                      onChange={handleTab3Change}
                                      className="form-control"
                                      id="basicpill-suib-input7"
                                      placeholder="Enter English Sub Title."
                                      value={tab3?.eng_sub_title}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-ygksd-input8">
                                      Tamil Sub Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CustomTamilInput
                                      value={tab3.tamil_tsub_title}
                                      name={"tamil_tsub_title"}
                                      setValue={e =>
                                        setTab3(p => ({
                                          ...p,
                                          tamil_tsub_title: e,
                                        }))
                                      }
                                    />
                                    {/* <Input
                                                                            type="text"
                                                                            name="tamil_tsub_title"
                                                                            onChange={handleTab3Change}
                                                                            className="form-control"
                                                                            id="basicpill-ygksd-input8"
                                                                            placeholder="Enter Tamil Sub Title."
                                                                        /> */}
                                  </div>
                                </Col>
                              </Row>
                            </Form>

                            <h6 className="mb-3 mt-3 card-title">
                              Commitment <span className="text-danger">*</span>
                            </h6>
                            <Form
                              className="repeater"
                              encType="multipart/form-data"
                            >
                              <div>
                                {(tab3.commitment_lists || []).map(
                                  (formRow, key) => (
                                    <Row
                                      key={key}
                                      className="align-items-center"
                                    >
                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="comm_eng_title">
                                          English Title
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          id="comm_eng_title"
                                          name={`comm_eng_title_${formRow.id}`}
                                          value={formRow.comm_eng_title}
                                          onChange={e =>
                                            handleInputChange2(
                                              formRow.id,
                                              "comm_eng_title",
                                              e.target.value
                                            )
                                          }
                                          className="form-control"
                                          placeholder="Enter English Title"
                                        />
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="comm_tamil_title">
                                          Tamil Title
                                          <span className="text-danger">*</span>
                                        </label>
                                        {/* <input
                                                                                type="text"
                                                                                id="comm_tamil_title"
                                                                                name={`comm_tamil_title_${formRow.id}`}
                                                                                value={formRow.comm_tamil_title}
                                                                                onChange={(e) => handleInputChange2(formRow.id, 'comm_tamil_title', e.target.value)}
                                                                                className="form-control"
                                                                                placeholder="Enter Tamil Title"
                                                                            /> */}
                                        <CustomTamilInput
                                          value={formRow.comm_tamil_title}
                                          name={`comm_tamil_title${formRow.id}`}
                                          setValue={e =>
                                            handleInputChange2(
                                              formRow.id,
                                              "comm_tamil_title",
                                              e
                                            )
                                          }
                                        />
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="comm_eng_sub_title">
                                          English Sub Title
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          id="comm_eng_sub_title"
                                          name={`comm_eng_sub_title_${formRow.id}`}
                                          value={formRow.comm_eng_sub_title}
                                          onChange={e =>
                                            handleInputChange2(
                                              formRow.id,
                                              "comm_eng_sub_title",
                                              e.target.value
                                            )
                                          }
                                          className="form-control"
                                          placeholder="Enter English Sub Title"
                                        />
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="comm_tamil_tsub_title">
                                          Tamil Sub Title
                                          <span className="text-danger">*</span>
                                        </label>
                                        {/* <input
                                                                                type="text"
                                                                                id="comm_tamil_tsub_title"
                                                                                name={`comm_tamil_tsub_title_${formRow.id}`}
                                                                                value={formRow.comm_tamil_tsub_title}
                                                                                onChange={(e) => handleInputChange2(formRow.id, 'comm_tamil_tsub_title', e.target.value)}
                                                                                className="form-control"
                                                                                placeholder="Enter Tamil Sub Title"
                                                                            /> */}
                                        <CustomTamilInput
                                          value={formRow.comm_tamil_tsub_title}
                                          name={`comm_tamil_tsub_title${formRow.id}`}
                                          setValue={e =>
                                            handleInputChange2(
                                              formRow.id,
                                              "comm_tamil_tsub_title",
                                              e
                                            )
                                          }
                                        />
                                      </Col>

                                      {key > 0 && (
                                        <Col
                                          lg={2}
                                          className="mb-2 align-self-center"
                                        >
                                          <div className="d-grid">
                                            <input
                                              type="button"
                                              className="btn btn-danger"
                                              value="Delete"
                                              onClick={() =>
                                                onDeleteFormRow2(formRow.id)
                                              }
                                            />
                                          </div>
                                        </Col>
                                      )}
                                    </Row>
                                  )
                                )}
                              </div>
                              <input
                                type="button"
                                className="btn btn-success mt-3 mt-lg-0"
                                value="Add Commitment"
                                onClick={() => onAddFormRow2()}
                              />
                            </Form>
                          </div>
                        </TabPane>

                        <TabPane tabId={4}>
                          <div>
                            {/* <div className="d-flex justify-content-end w-100">
                                                            <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                                                setshow((p) => {
                                                                    const h = [...p];
                                                                    h[3] = !h[3];
                                                                    return h;
                                                                })
                                                            }}>{show[3] ? "Show" : 'Hidden'}</button>

                                                        </div> */}
                            <Form>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-eng-input5">
                                      English Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      type="text"
                                      name="eng_title"
                                      onChange={handleTab4Change}
                                      className="form-control"
                                      id="basicpill-eng-input5"
                                      placeholder="Enter English Title."
                                      value={tab4?.eng_title}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-hgsd-input6">
                                      Tamil Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    {/* <Input
                                                                            type="text"
                                                                            name="tamil_title"
                                                                            onChange={handleTab4Change}
                                                                            className="form-control"
                                                                            id="basicpill-hgsd-input6"
                                                                            placeholder="Enter Tamil Title."
                                                                        /> */}
                                    <CustomTamilInput
                                      value={tab4.tamil_title}
                                      name={"tamil_title"}
                                      setValue={e =>
                                        setTab4(p => ({ ...p, tamil_title: e }))
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-suib-input7">
                                      English Sub Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      type="text"
                                      name="eng_sub_title"
                                      onChange={handleTab4Change}
                                      className="form-control"
                                      id="basicpill-suib-input7"
                                      placeholder="Enter English Sub Title."
                                      value={tab4?.eng_sub_title}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-ygksd-input8">
                                      Tamil Sub Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    {/* <Input
                                                                            type="text"
                                                                            name="tamil_tsub_title"
                                                                            onChange={handleTab4Change}
                                                                            className="form-control"
                                                                            id="basicpill-ygksd-input8"
                                                                            placeholder="Enter Tamil Sub Title."
                                                                        /> */}
                                    <CustomTamilInput
                                      value={tab4.tamil_tsub_title}
                                      name={"tamil_tsub_title"}
                                      setValue={e =>
                                        setTab4(p => ({
                                          ...p,
                                          tamil_tsub_title: e,
                                        }))
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Form>

                            <h6 className="mb-3 mt-3 card-title">
                              Gallery<span className="text-danger">*</span>
                            </h6>
                            <Form
                              className="repeater"
                              encType="multipart/form-data"
                            >
                              <div>
                                {(tab4.gallery_lists || []).map(
                                  (formRow, key) => (
                                    <Row
                                      key={key}
                                      className="align-items-center"
                                    >
                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="gallery_eng_name">
                                          English Title
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          id="gallery_eng_name"
                                          name={`gallery_eng_name_${formRow.id}`}
                                          value={formRow.gallery_eng_name}
                                          onChange={e =>
                                            handleInputChange3(
                                              formRow.id,
                                              "gallery_eng_name",
                                              e.target.value
                                            )
                                          }
                                          className="form-control"
                                          placeholder="Enter English Title"
                                        />
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="gallery_tamil_name">
                                          Tamil Title
                                          <span className="text-danger">*</span>
                                        </label>
                                        {/* <input
                                                                                type="text"
                                                                                id="gallery_tamil_name"
                                                                                name={`gallery_tamil_name_${formRow.id}`}
                                                                                value={formRow.gallery_tamil_name}
                                                                                onChange={(e) => handleInputChange3(formRow.id, 'gallery_tamil_name', e.target.value)}
                                                                                className="form-control"
                                                                                placeholder="Enter Tamil Title"
                                                                            /> */}
                                        <CustomTamilInput
                                          value={formRow.gallery_tamil_name}
                                          name={`gallery_tamil_name_${formRow.id}`}
                                          setValue={e =>
                                            handleInputChange3(
                                              formRow.id,
                                              "gallery_tamil_name",
                                              e
                                            )
                                          }
                                        />
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="top1_image">
                                          Top 1 Image
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="file"
                                          id="top1_image"
                                          name={`top1_image_${formRow.id}`}
                                          // value={formRow.top1_image}
                                          onChange={e =>
                                            handleInputChange3(
                                              formRow.id,
                                              "top1_image",
                                              e.target.files[0]
                                            )
                                          }
                                          className="form-control"
                                        />
                                        {formRow?.top1_image && (
                                          <div
                                            className="btn btn-primary mt-2"
                                            type="button"
                                            onClick={() => {
                                              getImg(formRow?.top1_image)
                                            }}
                                          >
                                            Preview
                                          </div>
                                        )}
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="top2_image">
                                          Top 2 Image
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="file"
                                          id="top2_image"
                                          name={`top2_image_${formRow.id}`}
                                          // value={formRow.top2_image}
                                          onChange={e =>
                                            handleInputChange3(
                                              formRow.id,
                                              "top2_image",
                                              e.target.files[0]
                                            )
                                          }
                                          className="form-control"
                                          placeholder=""
                                        />
                                        {formRow?.top2_image && (
                                          <div
                                            className="btn btn-primary mt-2"
                                            type="button"
                                            onClick={() => {
                                              getImg(formRow?.top2_image)
                                            }}
                                          >
                                            Preview
                                          </div>
                                        )}
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="top3_image">
                                          Top 3 Image
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="file"
                                          id="top3_image"
                                          name={`top3_image_${formRow.id}`}
                                          // value={formRow.top3_image}
                                          onChange={e =>
                                            handleInputChange3(
                                              formRow.id,
                                              "top3_image",
                                              e.target.files[0]
                                            )
                                          }
                                          placeholder=""
                                          className="form-control"
                                        />
                                        {formRow?.top3_image && (
                                          <div
                                            className="btn btn-primary mt-2"
                                            type="button"
                                            onClick={() => {
                                              getImg(formRow?.top3_image)
                                            }}
                                          >
                                            Preview
                                          </div>
                                        )}
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="left_center">
                                          Left Center
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="file"
                                          className="form-control"
                                          id="left_center"
                                          name={`left_center_${formRow.id}`}
                                          // value={formRow.left_center}
                                          onChange={e =>
                                            handleInputChange3(
                                              formRow.id,
                                              "left_center",
                                              e.target.files[0]
                                            )
                                          }
                                        />
                                        {formRow?.left_center && (
                                          <div
                                            className="btn btn-primary mt-2"
                                            type="button"
                                            onClick={() => {
                                              getImg(formRow?.left_center)
                                            }}
                                          >
                                            Preview
                                          </div>
                                        )}
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="center">Center <span className="text-danger">*</span></label>
                                        <input
                                          type="file"
                                          className="form-control"
                                          id="center"
                                          name={`center_${formRow.id}`}
                                          // value={formRow.center}
                                          onChange={e =>
                                            handleInputChange3(
                                              formRow.id,
                                              "center",
                                              e.target.files[0]
                                            )
                                          }
                                        />
                                        {formRow?.center && (
                                          <div
                                            className="btn btn-primary mt-2"
                                            type="button"
                                            onClick={() => {
                                              getImg(formRow?.center)
                                            }}
                                          >
                                            Preview
                                          </div>
                                        )}
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="right_center">
                                          Right center
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="file"
                                          className="form-control"
                                          id="right_center"
                                          name={`right_center_${formRow.id}`}
                                          // value={formRow.right_center}
                                          onChange={e =>
                                            handleInputChange3(
                                              formRow.id,
                                              "right_center",
                                              e.target.files[0]
                                            )
                                          }
                                        />
                                        {formRow?.right_center && (
                                          <div
                                            className="btn btn-primary mt-2"
                                            type="button"
                                            onClick={() => {
                                              getImg(formRow?.right_center)
                                            }}
                                          >
                                            Preview
                                          </div>
                                        )}
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="bottom1_image">
                                          Bottom 1 Image
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="file"
                                          className="form-control"
                                          id="bottom1_image"
                                          name={`bottom1_image_${formRow.id}`}
                                          // value={formRow.bottom1_image}
                                          onChange={e =>
                                            handleInputChange3(
                                              formRow.id,
                                              "bottom1_image",
                                              e.target.files[0]
                                            )
                                          }
                                        />
                                        {formRow?.bottom1_image && (
                                          <div
                                            className="btn btn-primary mt-2"
                                            type="button"
                                            onClick={() => {
                                              getImg(formRow?.bottom1_image)
                                            }}
                                          >
                                            Preview
                                          </div>
                                        )}
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="bottom2_image">
                                          Bottom 2 Image
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="file"
                                          className="form-control"
                                          id="bottom2_image"
                                          name={`bottom2_image_${formRow.id}`}
                                          // value={formRow.bottom2_image}
                                          onChange={e =>
                                            handleInputChange3(
                                              formRow.id,
                                              "bottom2_image",
                                              e.target.files[0]
                                            )
                                          }
                                        />
                                        {formRow?.bottom2_image && (
                                          <div
                                            className="btn btn-primary mt-2"
                                            type="button"
                                            onClick={() => {
                                              getImg(formRow?.bottom2_image)
                                            }}
                                          >
                                            Preview
                                          </div>
                                        )}
                                      </Col>

                                      <Col lg={6} className="mb-3">
                                        <label htmlFor="bottom3_image">
                                          Bottom 3 Image
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="file"
                                          className="form-control"
                                          id="bottom3_image"
                                          name={`bottom3_image_${formRow.id}`}
                                          // value={formRow.bottom3_image}
                                          onChange={e =>
                                            handleInputChange3(
                                              formRow.id,
                                              "bottom3_image",
                                              e.target.files[0]
                                            )
                                          }
                                        />
                                        {formRow?.bottom3_image && (
                                          <div
                                            className="btn btn-primary mt-2"
                                            type="button"
                                            onClick={() => {
                                              getImg(formRow?.bottom3_image)
                                            }}
                                          >
                                            Preview
                                          </div>
                                        )}
                                      </Col>

                                      {key > 0 && (
                                        <Col
                                          lg={2}
                                          className="mb-2 align-self-center"
                                        >
                                          <div className="d-grid">
                                            <input
                                              type="button"
                                              className="btn btn-danger"
                                              value="Delete"
                                              onClick={() =>
                                                onDeleteFormRow3(formRow.id)
                                              }
                                            />
                                          </div>
                                        </Col>
                                      )}
                                    </Row>
                                  )
                                )}
                              </div>
                              <input
                                type="button"
                                className="btn btn-success mt-3 mt-lg-0"
                                value="Add Gallery"
                                onClick={() => onAddFormRow3()}
                              />
                            </Form>
                          </div>
                        </TabPane>

                        <TabPane tabId={5}>
                          <div>
                            {/* <div className="d-flex justify-content-end w-100">
                                    <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                        setshow((p) => {
                                            const h = [...p];
                                            h[1] = !h[1];
                                            return h;
                                        })
                                    }}>{show[1] ? "Show" : 'Hidden'}</button>
                                </div> */}

                            <Form>
                              {(tab5 || []).map((formRow, key) => (
                                <Row key={key}>
                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-eng-input5">
                                        English Title{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Input
                                        type="text"
                                        name="eng_title"
                                        onChange={e =>
                                          handleInputChange5(
                                            formRow.id,
                                            "eng_title",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        id="basicpill-eng-input5"
                                        placeholder="Enter English Title."
                                        value={formRow?.eng_title}
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-hgsd-input6">
                                        Tamil Title{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <CustomTamilInput
                                        value={formRow.tamil_title}
                                        name={"tamil_title"}
                                        setValue={e =>
                                          handleInputChange5(
                                            formRow.id,
                                            "tamil_title",
                                            e
                                          )
                                        }
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-eng-input5">
                                        English Description{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Input
                                        type="text"
                                        name="eng_desc"
                                        onChange={e =>
                                          handleInputChange5(
                                            formRow.id,
                                            "eng_desc",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        id="basicpill-eng-input5"
                                        placeholder="Enter English Description."
                                        value={formRow?.eng_desc}
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-hgsd-input6">
                                        Tamil Description{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <CustomTamilInput
                                        value={formRow.tamil_desc}
                                        name={"tamil_desc"}
                                        setValue={e =>
                                          handleInputChange5(
                                            formRow.id,
                                            "tamil_desc",
                                            e
                                          )
                                        }
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-eng-input5">
                                        Redirect URL{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Input
                                        type="text"
                                        name="redirect_url"
                                        onChange={e =>
                                          handleInputChange5(
                                            formRow.id,
                                            "redirect_url",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        id="basicpill-eng-input5"
                                        placeholder="Enter Redirect URL"
                                        value={formRow?.redirect_url}
                                      />
                                    </div>
                                  </Col>

                                  {key > 1 && (
                                    <Col
                                      lg={2}
                                      className="mb-2 align-self-center"
                                    >
                                      <div className="d-grid">
                                        <input
                                          type="button"
                                          className="btn btn-danger"
                                          value="Delete"
                                          onClick={() =>
                                            onDeleteFormRow5(formRow.id)
                                          }
                                        />
                                      </div>
                                    </Col>
                                  )}
                                </Row>
                              ))}

                              <input
                                type="button"
                                className="btn btn-success mt-3 mt-lg-0"
                                value="Add News Feed"
                                onClick={() => onAddFormRow5()}
                              />
                            </Form>
                          </div>
                        </TabPane>

                        <TabPane tabId={6}>
                          <div>
                            {/* <div className="d-flex justify-content-end w-100">
                                    <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                        setshow((p) => {
                                            const h = [...p];
                                            h[1] = !h[1];
                                            return h;
                                        })
                                    }}>{show[1] ? "Show" : 'Hidden'}</button>
                                </div> */}

                            <Form>
                              {(tab6 || []).map((formRow, key) => (
                                <Row key={key}>
                                 <Col lg={6} className="mb-3">
                                        <label htmlFor="bottom1_image">
                                        Image <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="file"
                                          className="form-control"
                                          id="image_path"
                                          name={`image_path_${formRow.id}`}
                                          // value={formRow.bottom1_image}
                                          onChange={e =>
                                            handleInputChange6(
                                              formRow.id,
                                              "image_path",
                                              e.target.files[0]
                                            )
                                          }
                                        />
                                        {formRow?.image_path && (
                                          <div
                                            className="btn btn-primary mt-2"
                                            type="button"
                                            onClick={() => {
                                              getImg(formRow?.image_path)
                                            }}
                                          >
                                            Preview
                                          </div>
                                        )}
                                      </Col>

                                  <Col lg="6">
                                    <div className="mb-3">
                                      <Label for="basicpill-eng-input5">
                                        Redirect URL{" "}
                                        <span className="text-danger">*</span>
                                      </Label>
                                      <Input
                                        type="text"
                                        name="redirect_url"
                                        onChange={e =>
                                          handleInputChange6(
                                            formRow.id,
                                            "redirect_url",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        id="basicpill-eng-input5"
                                        placeholder="Enter Redirect URL"
                                        value={formRow?.redirect_url}
                                      />
                                    </div>
                                  </Col>

                                  {key > 0 && (
                                    <Col
                                      lg={2}
                                      className="mb-2 align-self-center"
                                    >
                                      <div className="d-grid">
                                        <input
                                          type="button"
                                          className="btn btn-danger"
                                          value="Delete"
                                          onClick={() =>
                                            onDeleteFormRow6(formRow.id)
                                          }
                                        />
                                      </div>
                                    </Col>
                                  )}
                                </Row>
                              ))}

                              <input
                                type="button"
                                className="btn btn-success mt-3 mt-lg-0"
                                value="Add More"
                                onClick={() => onAddFormRow6()}
                              />
                            </Form>
                          </div>
                        </TabPane>
                      </TabContent>
                    </div>

                    <div className="actions clearfix">
                      <ul>
                        <li
                          className={
                            activeTab === 1 ? "previous disabled" : "previous"
                          }
                        >
                          <button
                            style={{
                              backgroundColor: "#556ee6",
                              borderRadius: "4px",
                              padding: "8px 15px",
                              color: "#fff",
                              border: "none",
                            }}
                            onClick={() => {
                              toggleTab(activeTab - 1)
                            }}
                          >
                            Previous
                          </button>
                        </li>
                        <li className={activeTab === 6 ? "submit" : "next"}>
                          {activeTab === 6 ? (
                            <button
                              type="button"
                              onClick={() => handleTab6Verify()}
                              className="btn btn-primary"
                            >
                              {isLoading ? (
                                <>
                                  <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                  Loading
                                </>
                              ) : (
                                "Submit"
                              )}
                            </button>
                          ) : (
                            <button
                              onClick={() => {
                                if (activeTab == 1) {
                                  if (!show[0] || handleTab1Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                } else if (activeTab == 2) {
                                  if (!show[1] || handleTab2Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                } else if (activeTab == 3) {
                                  if (!show[2] || handleTab3Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                } else if (activeTab == 4) {
                                  if (!show[0] || handleTab4Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                } else if (activeTab == 5) {
                                  if (handleTab5Verify()) {
                                  toggleTab(activeTab + 1)
                                  }
                                } else if (activeTab == 6) {
                                  // if (handleTab5Verify()) {
                                  toggleTab(activeTab + 1)
                                  // }
                                }
                              }}
                            >
                              Next
                            </button>
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default withRouter(HomePage)
